"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'quicksilver',
    client_id: '07-tendermint-16',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'regen',
    client_id: '07-tendermint-113',
    connection_id: 'connection-102'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-17',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-61',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1'
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'quicksilver',
    client_id: '07-tendermint-28',
    connection_id: 'connection-14'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-138',
    connection_id: 'connection-99'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-52',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-65',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1'
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'quicksilver',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'stargaze',
    client_id: '07-tendermint-225',
    connection_id: 'connection-159'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-124',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1'
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'quicksilver',
    client_id: '07-tendermint-27',
    connection_id: 'connection-13'
  },
  chain_2: {
    chain_name: 'umee',
    client_id: '07-tendermint-183',
    connection_id: 'connection-122'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-49',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-53',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1'
  }]
}];
var _default = exports["default"] = info;